import { pnDueActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    epno: undefined
};

export const reducer = createReducer(initialState, {
    [pnDueActions.loadDetailsSuccess]: (state, action) => {
        let result;
        result = action.payload.details.pnduedetails[0] ? action.payload.details.pnduedetails[0] : {};
        return result;
    },
    [pnDueActions.clearSelection]: (state, action) => {
        return ({ epno: undefined });
    }
})


